import { useTranslation } from '../../useTranslation';
import { useConditionalContentErrors } from './useConditionalContentErrors';

enum CLAUSE_KEYS {
  IF = 'ifClause',
  ELSE_IF = 'elseIfClauses',
}

export const useConditionalContentErrorMessage = () => {
  const { t } = useTranslation();
  const errors = useConditionalContentErrors();
  const hasContentError = !!errors?.message;
  const errorKeys = Object.keys(errors || {});
  const hasFieldErrors =
    errorKeys.includes(CLAUSE_KEYS.IF) || errorKeys.includes(CLAUSE_KEYS.ELSE_IF);
  if (hasContentError && hasFieldErrors) {
    return t('conditionalContent.conditionsAndContentLengthError');
  } else if (!hasContentError && hasFieldErrors) {
    return t('conditionalContent.conditions.unfulfilledInputs');
  } else if (hasContentError && !hasFieldErrors) {
    return errors?.message;
  }
};
